import { BaseField, BaseFieldModel } from '../baseField';
import { FieldType } from '../fieldType';

export type YesNoNaType = 'yes' | 'no' | 'na' | undefined;

export interface YesNoFieldModel extends BaseFieldModel {
  defaultValue: YesNoNaType;
  allowNa: boolean;
  type: FieldType.YesNo;
}

export class YesNoField extends BaseField implements YesNoFieldModel {
  public defaultValue: YesNoNaType;
  public allowNa = true;
  public type: FieldType.YesNo = FieldType.YesNo;

  constructor(cultures: string[]) {
    super(FieldType.YesNo, cultures);
  }
}
